let state = {
  //自助商标复审
  reviewInfo: {}, //首页相关信息
  applicantInfo:{}, //材料页 联系人信息
  evidenceMaterial:{}, //材料页 证据信息
  productList:{},

  //专业商标复审
  PFreviewInfo: {}, //首页相关信息
  PFproductList:{}, 
  PFcontactInfo:{}, //材料页 联系人信息

  // 订单信息
  orderInfo:{}
};

export default state;
